export default __webpack_public_path__ + "static/media/multiple-branch-image-homepage.af79c30f.png";